var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1644 9H2.83556C2.37409 9 2 9.42085 2 9.94V10.06C2 10.5791 2.37409 11 2.83556 11H17.1644C17.6259 11 18 10.5791 18 10.06V9.94C18 9.42085 17.6259 9 17.1644 9Z",
    fill: "#1E9B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1644 14H2.83556C2.37409 14 2 14.4209 2 14.94V15.06C2 15.5791 2.37409 16 2.83556 16H17.1644C17.6259 16 18 15.5791 18 15.06V14.94C18 14.4209 17.6259 14 17.1644 14Z",
    fill: "#1E9B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1644 4H2.83556C2.37409 4 2 4.42085 2 4.94V5.06C2 5.57915 2.37409 6 2.83556 6H17.1644C17.6259 6 18 5.57915 18 5.06V4.94C18 4.42085 17.6259 4 17.1644 4Z",
    fill: "#1E9B6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHamburger);
export default __webpack_public_path__ + "static/media/greenHamburger.115129cfbcdbc479f7734a94b17f64a4.svg";
export { ForwardRef as ReactComponent };